
import watchCreateOnboardingNovaConta from './saga/create';

export const onboardingSaga = [
    watchCreateOnboardingNovaConta(),
]

export * from './actionTypes';
export * from './reducer';
export * from './entity';
